import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnidadOrganizacional } from '../models/UnidadOrganizacional';
import { environment } from '../../environments/environment';
import { Buzon } from '../models/Buzon';
import { Participante } from '../models/ParticipanteType';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BuzonService {

  private url = environment.apiUrl+"uo/j";
  private URL_BUSCAR_BUZON = environment.apiUrl + 'buzon/b';
  private URL_BUZON = environment.apiUrl + 'buzon';
  private readonly URL_GET_BUZONES_USUARIO = environment.apiUrl + 'buzon/usuario';
  private URL_DELETE_BUZON = environment.apiUrl + 'buzon/';

  constructor(
    private http: HttpClient
  ) { }
  
  getDepartamentos(): Observable<UnidadOrganizacional[]> {
      return this.http.get<UnidadOrganizacional[]>(this.url);
  }

  getServidorPublicoActual(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+"sp/a");
  }

  create(buzon: Buzon): Observable<Buzon> {
    return this.http.post<Buzon>(`${this.URL_BUZON}/usuario/uo`, buzon);
  }

  selectAll(criterio?: string): Observable<Buzon[]> {
    let params = new HttpParams();
    if (criterio && criterio.trim().length > 0) {
      params = params.append('criterio', criterio.trim());
    }

    return this.http.get<Buzon[]>(this.URL_BUZON + "/usuario/uo", { params });
  }

  update(buzon: Buzon): Observable<Buzon> {
    return this.http.put<Buzon>(`${this.URL_BUZON}/usuario/uo/${buzon.id}`, buzon);
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.url+"/uo");
  }
  
  buscarBuzon(criterio: string): Observable<Buzon[]> {
    let params = new HttpParams();
    params = params.append('criterio', criterio);

    return this.http.get<Buzon[]>(this.URL_BUSCAR_BUZON, { params });
  }
  
  getBuzonesUsuario(): Observable<Buzon[]> {
    return this.http.get<Buzon[]>(this.URL_GET_BUZONES_USUARIO);
  }

  deleteBuzon(id: number): Observable<void> {
    const url = `${this.URL_DELETE_BUZON}${id}`;
    return this.http.delete<void>(url);
  }

  getIntegrantes(buzonId: number): Observable<Participante[]> {
    const url = `${this.URL_BUZON}/${buzonId}/integrantes`;
    return this.http.get<Participante[]>(url);
  }
}
